<template>
  <div
    class="container question-filter-dialog pt-3 pb-5"
  >
    <div class="row mb-3">
      <div class="col-12">
        <h3>
          Filtrar por questões
        </h3>
      </div>
    </div>
    <div
      v-if="!loading"
      class="row"
    >
      <div class="col-12">
        <div
          v-for="(question, index) in selected_answers"
          :key="index"
        >
          <span
            v-html="question.title"
          ></span>
          <div
            v-for="(answer, answer_index) in question.options"
            :key="`answer_${answer_index}`"
            class="ml-3"
          >
            <label :for="answer.key">
              <input
                type="checkbox"
                :id="answer.key"
                :value="answer.key"
                @change="selectOption(answer.key)"
              />
              {{ getText(answer, question.title) }}
            </label>
          </div>
          <hr />
        </div>
      </div>
    </div>
  </div>    
</template>

<script>
export default {
  props: {
    questions: {
      type: Array,
      required: true
    },
    answers: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      selected_answers: [],
      loading: true,
      selected_option: null
    }
  },

  mounted() {
    this.questions.forEach((question,index) => {
      if (question.response_type == 2){
        this.selected_answers.push({
          title: question.title,
          options: []
        });
        const options = this.answers.buckets.filter((answer) => answer.key.split("-")[0].trim() == question.id);
        if (options.length == 0) {
          return;
        }
        options.forEach((option) => {
          this.selected_answers[this.selected_answers.length - 1].options.push({
            key: option.key,
            doc_count: option.doc_count
          });
        });
      }
    });
    this.loading = false;
  },

  methods: {
    getText(answer) {
      let key = answer.key.split("|||")[1];
      const doc_count = answer.doc_count;
      return `${key} (${doc_count})`;
    },
    selectOption(option) {
      this.selected_option = option;
      eventBus.$emit('closeQuestionFilterDialog', option);
    }
  }
}
</script>

<style>
.question-filter-dialog {
  max-height: 80vh;
  overflow-y: auto;
}
</style>